module.exports = __webpack_public_path__ + "img/playbutton6.9ddbd987.png";